import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Form from './form';
import View from './view';

export function Overview({ editing }) {
  return (
    <div className="deal">
      {editing
        ? <Form/>
        : <View/>
      }
    </div>
  );
}

Overview.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = state => ({
  editing: state.overview.editing,
});

export default connect(mapStateToProps)(Overview);
